export default class FrontPage {
  constructor() {
    if (!$('.front-page').length) return;

    this.setSectionsHeight();
    $(window).on('resize', () => {
      this.setSectionsHeight();
    });
  }

  setSectionsHeight() {
    const headerHeight = $('.header').height();
    const windowHeight = $(window).height();
    let menuHeight;
    if($(window).width() > 992) {
      menuHeight = $('.header__main-nav').height();
      // $('section').height(windowHeight - menuHeight - 45);
      $('section').css('min-height', `${windowHeight - menuHeight - 45}px`);
    } else if($(window).width() > 600 ) {
      menuHeight = $('.header--mobile__main-nav').height();
      // $('section').height(windowHeight - menuHeight - 45);
      $('section').css('min-height', `${windowHeight - menuHeight - 45}px`);
    } else {
      menuHeight = $('.header--mobile__main-nav').height();
      $('section').css('min-height', 'none');
      $('section').css('height', 'auto');
    }

    if(window.scrollY != 0) {
      if($(window).width() > 992) {
        $('.hero').height(windowHeight - (headerHeight + menuHeight + 45));
      } else {
        $('.hero').height(windowHeight - (headerHeight + menuHeight));
      }
    } else {
      $('.hero').height(windowHeight - headerHeight);
    }
  }
}


// WEBPACK FOOTER //
// ./scripts/components/frontPage.js